import LostFoundDialogs from "@/components/lost-found/LostFoundDialogs";
import { LostItem } from "@/types";

interface LostFoundModalsProps {
  newItemOpen: boolean;
  setNewItemOpen: (open: boolean) => void;
  editItemOpen: boolean;
  setEditItemOpen: (open: boolean) => void;
  selectedItem: LostItem | null;
  signatureModalOpen: boolean;
  setSignatureModalOpen: (open: boolean) => void;
  handleConfirmSignature: (signature: string, receiver: string) => void;
  timelineModalOpen: boolean;
  setTimelineModalOpen: (open: boolean) => void;
  infoModalOpen: boolean;
  setInfoModalOpen: (open: boolean) => void;
  deleteDialogOpen: boolean;
  setDeleteDialogOpen: (open: boolean) => void;
  confirmDelete: () => void;
  discardDialogOpen: boolean;
  setDiscardDialogOpen: (open: boolean) => void;
  confirmDiscard: () => void;
}

const LostFoundModals = (props: LostFoundModalsProps) => (
  <>
    <LostFoundDialogs
      editItemOpen={props.editItemOpen}
      setEditItemOpen={props.setEditItemOpen}
      selectedItem={props.selectedItem}
      signatureModalOpen={props.signatureModalOpen}
      setSignatureModalOpen={props.setSignatureModalOpen}
      handleConfirmSignature={props.handleConfirmSignature}
      timelineModalOpen={props.timelineModalOpen}
      setTimelineModalOpen={props.setTimelineModalOpen}
      infoModalOpen={props.infoModalOpen}
      setInfoModalOpen={props.setInfoModalOpen}
      deleteDialogOpen={props.deleteDialogOpen}
      setDeleteDialogOpen={props.setDeleteDialogOpen}
      confirmDelete={props.confirmDelete}
      discardDialogOpen={props.discardDialogOpen}
      setDiscardDialogOpen={props.setDiscardDialogOpen}
      confirmDiscard={props.confirmDiscard}
    />
  </>
);

export default LostFoundModals;
